import { render, staticRenderFns } from "./MetaDescription.vue?vue&type=template&id=61a6709f&scoped=true"
import script from "./MetaDescription.vue?vue&type=script&lang=js"
export * from "./MetaDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6709f",
  null
  
)

export default component.exports